/*
 * @Author: zhang lin
 * @Date: 2022-04-07 14:28:49
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-12-27 13:57:18
 * @Description: file content
 */
import React from 'react';
import styles from './index.less';
import { Steps } from 'sup-ui';
import Icon from 'root/components/Icon';
import { useIntl } from 'react-intl';
import messages from 'root/pages/InstallSupos/messages';
import { useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';

const { Step } = Steps;
interface PropsType {
  step: string;
}
const TitleHeader = (props: PropsType) => {
  const intl = useIntl();

  const { step } = props;
  const { cluster } = useSelector((state: reducerStates) => state.envManage);
  const stepList = cluster
    ? ['fileConfig', 'nodeConfig', 'authorization', 'database', 'installList']
    : ['fileConfig', 'deploy', 'database', 'installList'];

  // 更加step标识获取对应的步骤索引
  const getCur = () => {
    return stepList.indexOf(step);
  };

  return (
    <div className={styles.relative}>
      {step !== 'license' ? (
        <div className={styles.stepsBox}>
          <Steps current={getCur()} labelPlacement="vertical" size="small">
            <Step title={intl.formatMessage(messages.extAndApp)} icon={<Icon type="progressbar28_package_nor" />} />
            {cluster ? (
              <Step title={intl.formatMessage(messages.nodeConfig)} icon={<Icon type="progressbar28_server" />} />
            ) : (
              <Step title={intl.formatMessage(messages.systemConfig)} icon={<Icon type="progressbar28_server" />} />
            )}
            {cluster && (
              <Step title={intl.formatMessage(messages.authorization)} icon={<Icon type="progressbar28_server" />} />
            )}

            <Step title={intl.formatMessage(messages.databaseConfig)} icon={<Icon type="progressbar28_data_nor" />} />
            <Step title={intl.formatMessage(messages.install)} icon={<Icon type="progressbar28_install" />} />
          </Steps>
        </div>
      ) : null}
    </div>
  );
};
export default TitleHeader;
